export const IMG = {
    WALLET_CONNECT:
        'https://raw.githubusercontent.com/ton-connect/sdk/main/assets/walletconnect-icon-288.png'
};
